import styled from "styled-components";

export const ExpandableBodyRoot = styled.div`
    position: relative;
    width: 100%;

    display: flex;
    flex-direction: column;

    overflow: hidden;
    box-sizing: border-box;
`;
